import { FC, Fragment, ReactNode } from 'react'

const BOLD_TAG_PATTERN = /<(b|strong)>(.*?)<\/\1>/gi

/** IMPORTANT NOTICE ABOUT THIS COMPONENT
 *
 *  Renders disclaimer copy from env vars. Supports paragraph breaks (\n\n), line breaks (\n), and inline bold via <b> or <strong> only.
 *  Any other markup is shown as plain text (not parsed as HTML) for security reason
 *
 */

/** Env vars may contain literal `\n` sequences depending on how they are injected. */
export const normalizeDisclaimerNewlines = (text: string): string => text.replace(/\\n/g, '\n')

const parseInlineBold = (line: string, lineKey: string): ReactNode[] => {
  const nodes: ReactNode[] = []
  let lastIndex = 0
  let match: RegExpExecArray | null
  const pattern = new RegExp(BOLD_TAG_PATTERN.source, BOLD_TAG_PATTERN.flags)

  while ((match = pattern.exec(line)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(line.slice(lastIndex, match.index))
    }
    nodes.push(<b key={`${lineKey}-b-${match.index}`}>{match[2]}</b>)
    lastIndex = pattern.lastIndex
  }

  if (lastIndex < line.length) {
    nodes.push(line.slice(lastIndex))
  }

  return nodes.length > 0 ? nodes : [line]
}

export const FeatureDisclaimerTextComponent: FC<{ text: string }> = ({ text }) => {
  const normalized = normalizeDisclaimerNewlines(text)
  const paragraphs = normalized.split(/\n\n+/)

  return (
    <>
      {paragraphs.map((paragraph, paragraphIndex) => {
        const lines = paragraph.split('\n')

        return (
          <p key={paragraphIndex} className="feature-disclaimer-text__paragraph">
            {lines.map((line, lineIndex) => (
              <Fragment key={lineIndex}>
                {parseInlineBold(line, `${paragraphIndex}-${lineIndex}`)}
                {lineIndex < lines.length - 1 && <br />}
              </Fragment>
            ))}
          </p>
        )
      })}
    </>
  )
}
